import { render, staticRenderFns } from "./BasePurgeIcon.vue?vue&type=template&id=5ffdfa70&scoped=true"
import script from "./BasePurgeIcon.vue?vue&type=script&lang=js"
export * from "./BasePurgeIcon.vue?vue&type=script&lang=js"
import style0 from "./BasePurgeIcon.vue?vue&type=style&index=0&id=5ffdfa70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffdfa70",
  null
  
)

/* custom blocks */
import block0 from "./BasePurgeIcon.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports